var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    {
      staticClass: "bg-blue-box mt10",
      class: { "is-open": _vm.isOpenWorkLocation },
    },
    [
      _vm.isBulkRegistrationAddress
        ? [
            _c("dt", [_vm._v("勤務地一覧")]),
            _vm._v(" "),
            _c("dd", {
              staticClass: "pega-pre-wrap pega-preview-word-break",
              domProps: { textContent: _vm._s(_vm.valueBulkPlace) },
            }),
          ]
        : [
            _c("dt", [_vm._v("勤務地エリア")]),
            _vm._v(" "),
            _c("dd", {
              class: { shorten: _vm.shorten },
              attrs: { id: "work-location", "data-test": "workLocation" },
              domProps: { textContent: _vm._s(_vm.workLocation) },
            }),
            _vm._v(" "),
            _vm.showToggleButton
              ? _c(
                  "div",
                  {
                    staticStyle: { display: "block" },
                    attrs: { id: "job-location-accordion" },
                  },
                  [
                    _c("p", { on: { click: _vm.togglePlaceText } }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.buttonText) + "\n      "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }